var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('dashboard-content'),_c('content-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }